module.exports = __webpack_public_path__ + "img/icon-about-3.88b32b62.png";